import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgBilling = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-billing';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M5.24 7.04v2.8h1.52V5.76h6.48v5.04h5v8.56H13v1.52h6.76V10.04h-.763l.263-.246c.144-.135.258-.259.251-.276a237 237 0 0 0-2.488-2.536l-2.476-2.506-.245.242c-.134.133-.257.242-.273.242S14 4.798 14 4.6v-.36H5.24zm10.738 1.02 1.19 1.22H14.76V8.06c0-.671.006-1.22.014-1.22s.55.549 1.204 1.22M8.24 11.137v1.097l-.23.026c-1.021.116-1.832.708-2.135 1.56-.105.294-.144.906-.079 1.22.181.873.931 1.555 1.918 1.744.207.039.613.056 1.381.056 1.049 0 1.094.003 1.264.09.097.05.211.137.253.195.165.228.165.722 0 .95a.8.8 0 0 1-.253.195c-.176.09-.177.09-2.267.09H6v1.52h2.24V22h1.52v-2.11l.33-.027c.659-.054 1.11-.251 1.515-.663.426-.432.635-.956.635-1.586 0-.43-.056-.687-.23-1.054-.179-.377-.561-.774-.92-.955-.438-.221-.604-.245-1.708-.246-.551-.001-1.123-.017-1.271-.036-.553-.072-.842-.325-.842-.738 0-.243.114-.488.289-.617.273-.202.345-.208 2.463-.208H12v-1.52H9.76v-2.2H8.24z"
    })
  }));
});
export default SvgBilling;